import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useCallback } from 'react';

var _excluded = ["onChange", "onFocus", "onBlur", "name", "disabled", "focused"];
var useInput = function useInput(props, ref) {
  var onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      name = props.name,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      externalFocused = props.focused,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  var _useState = useState(false),
      focused = _useState[0],
      setFocused = _useState[1];

  var handleChange = useCallback(function (e) {
    if (typeof onChange === 'function' && !disabled) {
      onChange(e, {
        value: e.currentTarget.value,
        name: name
      });
    }
  }, [onChange, disabled]);
  var handleFocus = useCallback(function (e) {
    if (typeof onFocus === 'function') {
      onFocus(e);
    }

    setFocused(true);
  }, [onFocus]);
  var handleBlur = useCallback(function (e) {
    if (typeof onBlur === 'function') {
      onBlur(e);
    }

    setFocused(false);
  }, [onBlur]);
  var handleClickOnBox = useCallback(function () {
    if (ref.current) {
      ref.current.focus();
    }
  }, []);
  return _extends({}, attrs, {
    handleBlur: handleBlur,
    handleFocus: handleFocus,
    handleChange: handleChange,
    handleClickOnBox: handleClickOnBox,
    disabled: disabled,
    focused: externalFocused != null ? externalFocused : focused,
    name: name
  });
};

export { useInput };
